import { alpha } from '@mui/material/styles';

export default function Input(theme) {
  return {
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            '& svg': { color: theme.palette.text.disabled },
          },
        },
        input: {
          '&::placeholder': {
            opacity: 1,
            color: theme.palette.text.disabled,
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          '&:before': { borderBottomColor: theme.palette.grey[300] },
          '&:after': { borderBottomColor: theme.palette.primary.main },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.grey[100],
          borderRadius: 8,
          '&:hover': { backgroundColor: theme.palette.grey[200] },
          '&.Mui-focused': { backgroundColor: theme.palette.grey[100] },
          '&.Mui-disabled': { backgroundColor: theme.palette.action.disabledBackground },
        },
        underline: {
          '&:before': { borderBottomColor: theme.palette.grey[300] },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          backgroundColor: theme.palette.common.white,
          transition: 'border-color .15s ease, box-shadow .15s ease',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.grey[300],
            transition: 'border-color .15s ease',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.grey[400],
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main,
            borderWidth: 1,
            boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.12)}`,
          },
          '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.action.disabledBackground,
          },
          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.error.main,
          },
          '&.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
            boxShadow: `0 0 0 3px ${alpha(theme.palette.error.main, 0.12)}`,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.text.secondary,
          fontSize: theme.typography.pxToRem(14),
        },
      },
    },
  };
}
